import React, {useContext} from 'react'
import {Button, Divider} from "antd";
import {Table} from "react-bootstrap";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import UpdateProductionRows from "./UpdateProductionsRows";


const RecipeUpdateProductionCosts = () => {

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleNewRow = () => {
        let mockRows = Object.assign({}, recipeById)
        const obj = {ratio: 1}
        mockRows.recipeProductionCosts.push(obj)
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <h3>Üretim Maliyeti Listesi</h3>
            <Divider />
            <Button
                type={'link'}
                style={{marginBottom: '16px'}}
                onClick={handleNewRow}
            >
                Yeni Ekle
            </Button>
            <Table
                className={'recipe-table'}
                responsive
            >
                <thead>
                <tr>
                    <th>#</th>
                    <th>Gider Adı</th>
                    <th> Miktar (USD)</th>
                    <th>Toplam</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {
                    recipeById.recipeProductionCosts.map((item, index) => {
                        return <UpdateProductionRows key={index} id={index} row={item} />
                    })
                }
                </tbody>
            </Table>

        </React.Fragment>
    )
}
export default RecipeUpdateProductionCosts